<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M5.6 8.002H4a.8.8 0 1 0 0 1.6h1.6a.8.8 0 1 0 0-1.6Zm-.8-1.6H8a.8.8 0 1 0 0-1.6H4.8a.8.8 0 1 0 0 1.6Zm.8 4.799H4a.8.8 0 1 0 0 1.6h1.6a.8.8 0 1 0 0-1.6Zm9.6-3.2h-2.4V.804a.799.799 0 0 0-1.2-.696L9.2 1.483 6.8.107a.8.8 0 0 0-.8 0L3.6 1.483 1.2.107A.8.8 0 0 0 0 .803V13.6A2.4 2.4 0 0 0 2.4 16h11.2a2.4 2.4 0 0 0 2.4-2.4V8.802a.8.8 0 0 0-.8-.8Zm-12.8 6.4a.8.8 0 0 1-.8-.8V2.187l1.6.912a.864.864 0 0 0 .8 0l2.4-1.376 2.4 1.376a.864.864 0 0 0 .8 0l1.6-.912V13.6c.002.273.05.544.144.8H2.4Zm12-.8a.8.8 0 0 1-1.6 0v-4h1.6v4Zm-5.152-2.264a.61.61 0 0 0-.144-.072.8.8 0 0 0-.872.168A.84.84 0 0 0 8 12a.8.8 0 0 0 .056.304.952.952 0 0 0 .176.264.92.92 0 0 0 .264.168.75.75 0 0 0 .608 0 .92.92 0 0 0 .264-.168A.8.8 0 0 0 9.6 12a.84.84 0 0 0-.232-.568 1.274 1.274 0 0 0-.12-.096Zm.112-3.103a.8.8 0 0 0-1.296.263.8.8 0 0 0 .736 1.104.8.8 0 0 0 .8-.8.8.8 0 0 0-.064-.304.728.728 0 0 0-.176-.263Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
</template>
